"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.permissions = exports.dashboardTabsStatus = exports.Permissions = exports.Partner = exports.DashboardPages = void 0;
let DashboardPages = exports.DashboardPages = /*#__PURE__*/function (DashboardPages) {
  DashboardPages["Api"] = "Api";
  DashboardPages["BicycleObservatory"] = "BicycleObservatory";
  DashboardPages["CartographicData"] = "CartographicData";
  DashboardPages["Downloads"] = "Downloads";
  DashboardPages["GIS"] = "GIS";
  DashboardPages["Help"] = "Help";
  DashboardPages["Home"] = "Home";
  DashboardPages["Parkings"] = "Parkings";
  DashboardPages["Promotion"] = "Promotion";
  DashboardPages["QA"] = "QA";
  DashboardPages["Settings"] = "Settings";
  return DashboardPages;
}({});
let Permissions = exports.Permissions = /*#__PURE__*/function (Permissions) {
  Permissions["HOMEPAGE"] = "HOMEPAGE";
  Permissions["HOMEPAGE_ESSENTIELLE"] = "HOMEPAGE_ESSENTIELLE";
  Permissions["HOMEPAGE_EXTRAPOLATED"] = "HOMEPAGE_EXTRAPOLATED";
  Permissions["BICYCLE_FACILITIES"] = "BICYCLE_FACILITIES";
  Permissions["ROADS_QUALITY"] = "ROADS_QUALITY";
  Permissions["ISOCHRONES"] = "ISOCHRONES";
  Permissions["NETWORK_CYCLABILITY"] = "NETWORK_CYCLABILITY";
  Permissions["ACCIDENTALITY"] = "ACCIDENTALITY";
  Permissions["ACCIDENTALITY_EXTRAPOLATED"] = "ACCIDENTALITY_EXTRAPOLATED";
  Permissions["GEOVELO_ACTIVITY"] = "GEOVELO_ACTIVITY";
  Permissions["ROAD_USE"] = "ROAD_USE";
  Permissions["ROAD_USE_EXTRAPOLATED"] = "ROAD_USE_EXTRAPOLATED";
  Permissions["BICYCLE_TRAFFIC_FLUIDITY"] = "BICYCLE_TRAFFIC_FLUIDITY";
  Permissions["ORIGIN_DESTINATION"] = "ORIGIN_DESTINATION";
  Permissions["SUDDEN_BRAKINGS"] = "SUDDEN_BRAKINGS";
  Permissions["TRAVEL_SIMULATION"] = "TRAVEL_SIMULATION";
  Permissions["CONTRACTS_MANAGEMENT"] = "CONTRACTS_MANAGEMENT";
  Permissions["ACCESS_MANAGEMENT"] = "ACCESS_MANAGEMENT";
  Permissions["API"] = "API";
  Permissions["API_CREATE_API_KEY"] = "API_CREATE_API_KEY";
  Permissions["ANIMATION"] = "ANIMATION";
  Permissions["DOWNLOADS"] = "DOWNLOADS";
  Permissions["REFERENCE_ROUTES"] = "REFERENCE_ROUTES";
  Permissions["USERS_LOGS"] = "USERS_LOGS";
  Permissions["EXCLUSION_AREAS"] = "EXCLUSION_AREAS";
  Permissions["ITINERARY_REPORTS"] = "ITINERARY_REPORTS";
  Permissions["OSM_REPORTS"] = "OSM_REPORTS";
  Permissions["REPORTS"] = "REPORTS";
  Permissions["RIDES"] = "RIDES";
  Permissions["BIKE_ROUTES"] = "BIKE_ROUTES";
  Permissions["PARKINGS"] = "PARKINGS";
  Permissions["WIDGETS"] = "WIDGETS";
  Permissions["FACILITIES_SUGGESTIONS"] = "FACILITIES_SUGGESTIONS";
  Permissions["CVTC"] = "CVTC";
  Permissions["SIG_FILES"] = "SIG_FILES";
  Permissions["DISCONTINUITY"] = "DISCONTINUITY";
  return Permissions;
}({});
const permissions = exports.permissions = {
  [Permissions.HOMEPAGE]: {
    key: Permissions.HOMEPAGE
  },
  [Permissions.HOMEPAGE_ESSENTIELLE]: {
    key: Permissions.HOMEPAGE_ESSENTIELLE
  },
  [Permissions.HOMEPAGE_EXTRAPOLATED]: {
    key: Permissions.HOMEPAGE_EXTRAPOLATED
  },
  [Permissions.BICYCLE_FACILITIES]: {
    key: Permissions.BICYCLE_FACILITIES
  },
  [Permissions.ROADS_QUALITY]: {
    key: Permissions.ROADS_QUALITY
  },
  [Permissions.ISOCHRONES]: {
    key: Permissions.ISOCHRONES
  },
  [Permissions.NETWORK_CYCLABILITY]: {
    key: Permissions.NETWORK_CYCLABILITY
  },
  [Permissions.ACCIDENTALITY]: {
    key: Permissions.ACCIDENTALITY
  },
  [Permissions.ACCIDENTALITY_EXTRAPOLATED]: {
    key: Permissions.ACCIDENTALITY_EXTRAPOLATED
  },
  [Permissions.GEOVELO_ACTIVITY]: {
    key: Permissions.GEOVELO_ACTIVITY
  },
  [Permissions.ROAD_USE]: {
    key: Permissions.ROAD_USE
  },
  [Permissions.ROAD_USE_EXTRAPOLATED]: {
    key: Permissions.ROAD_USE_EXTRAPOLATED
  },
  [Permissions.BICYCLE_TRAFFIC_FLUIDITY]: {
    key: Permissions.BICYCLE_TRAFFIC_FLUIDITY
  },
  [Permissions.ORIGIN_DESTINATION]: {
    key: Permissions.ORIGIN_DESTINATION
  },
  [Permissions.SUDDEN_BRAKINGS]: {
    key: Permissions.SUDDEN_BRAKINGS
  },
  [Permissions.TRAVEL_SIMULATION]: {
    key: Permissions.TRAVEL_SIMULATION
  },
  [Permissions.ANIMATION]: {
    key: Permissions.ANIMATION
  },
  [Permissions.CONTRACTS_MANAGEMENT]: {
    key: Permissions.CONTRACTS_MANAGEMENT
  },
  [Permissions.ACCESS_MANAGEMENT]: {
    key: Permissions.ACCESS_MANAGEMENT
  },
  [Permissions.API]: {
    key: Permissions.API
  },
  [Permissions.API_CREATE_API_KEY]: {
    key: Permissions.API_CREATE_API_KEY
  },
  [Permissions.DOWNLOADS]: {
    key: Permissions.DOWNLOADS
  },
  [Permissions.REFERENCE_ROUTES]: {
    key: Permissions.REFERENCE_ROUTES
  },
  [Permissions.USERS_LOGS]: {
    key: Permissions.USERS_LOGS
  },
  [Permissions.EXCLUSION_AREAS]: {
    key: Permissions.EXCLUSION_AREAS
  },
  [Permissions.ITINERARY_REPORTS]: {
    key: Permissions.ITINERARY_REPORTS
  },
  [Permissions.OSM_REPORTS]: {
    key: Permissions.OSM_REPORTS
  },
  [Permissions.REPORTS]: {
    key: Permissions.REPORTS
  },
  [Permissions.RIDES]: {
    key: Permissions.RIDES
  },
  [Permissions.BIKE_ROUTES]: {
    key: Permissions.BIKE_ROUTES
  },
  [Permissions.PARKINGS]: {
    key: Permissions.PARKINGS
  },
  [Permissions.WIDGETS]: {
    key: Permissions.WIDGETS
  },
  [Permissions.FACILITIES_SUGGESTIONS]: {
    key: Permissions.FACILITIES_SUGGESTIONS
  },
  [Permissions.SIG_FILES]: {
    key: Permissions.SIG_FILES
  },
  [Permissions.DISCONTINUITY]: {
    key: Permissions.DISCONTINUITY
  }
};

// HOMEPAGE, HOMEPAGE_EXTRAPOLATED

// ROAD_USE, ROAD_USE_EXTRAPOLATED

// ACCESS_MANAGEMENT_READ_ONLY, ACCESS_MANAGEMENT_UPDATE

// API

// ANIMATION_READ_ONLY

// DOWNLOADS

// REPORTS

// BIKE_ROUTES

// PARKINGS

// WIDGETS_READ_ONLY, WIDGETS_UPDATE

const dashboardTabsStatus = exports.dashboardTabsStatus = {
  usageTravelSimulations: 'alpha',
  qaUsersLogs: 'support',
  exclusionZones: 'alpha',
  exclusionZonesForm: 'alpha',
  facilitiesSuggestions: 'alpha',
  facilitiesSuggestionsForm: 'alpha',
  cyclability: 'beta',
  extrapolation: 'alpha',
  discontinuity: 'beta',
  usageOriginDestination: 'beta',
  communityHomeWorkJourneys: 'beta'
};
class Partner {
  constructor(id, area, cyclabilityZoneId, code, title, icon, geoGroupId, bounds, administrativeLevel, isDefault, enableDashboardPageAccess, dashboardTabsPermissions, hasRealCounters, contactEmail, isUserAdmin, creationDate, whiteListedDomains, contracts, companyMaxSize, siren, hasStripeClient) {
    this.id = id;
    this.area = area;
    this.cyclabilityZoneId = cyclabilityZoneId;
    this.code = code;
    this.title = title;
    this.icon = icon;
    this.geoGroupId = geoGroupId;
    this.bounds = bounds;
    this.administrativeLevel = administrativeLevel;
    this.isDefault = isDefault;
    this.enableDashboardPageAccess = enableDashboardPageAccess;
    this.dashboardTabsPermissions = dashboardTabsPermissions;
    this.hasRealCounters = hasRealCounters;
    this.contactEmail = contactEmail;
    this.isUserAdmin = isUserAdmin;
    this.creationDate = creationDate;
    this.whiteListedDomains = whiteListedDomains;
    this.contracts = contracts;
    this.companyMaxSize = companyMaxSize;
    this.siren = siren;
    this.hasStripeClient = hasStripeClient;
  }
  get hasActivityStatistics() {
    return this.dashboardTabsPermissions.usageActivityStatistics !== 'none' && Boolean(this.geoGroupId) || false;
  }
  get hasCyclistsStatistics() {
    return this.geoGroupId && this.dashboardTabsPermissions.communityMembers !== 'none' || false;
  }
  get hasParkingsStatistics() {
    return this.geoGroupId && this.dashboardTabsPermissions.parkings !== 'none' || false;
  }
  get hasCyclabilityData() {
    return this.geoGroupId && this.dashboardTabsPermissions.cyclability !== 'none' || false;
  }
  clone() {
    return new Partner(this.id, this.area, this.cyclabilityZoneId, this.code, this.title, this.icon, this.geoGroupId, this.bounds, this.administrativeLevel, this.isDefault, this.enableDashboardPageAccess, this.dashboardTabsPermissions, this.hasRealCounters, this.contactEmail, this.isUserAdmin, this.creationDate, this.whiteListedDomains, this.contracts, this.companyMaxSize, this.siren, this.hasStripeClient);
  }
}
exports.Partner = Partner;